export const marketCountryCodes: Record<string, string> = {
  vic: 'au',
  nsw: 'au',
  nz: 'nz',
  washington: 'us',
  oregon: 'us',
  california: 'us',
}

// Collapses to /:country/:region when the market slug doubles as its country
// code; unknown markets fall back to the flat form, which the server 301s.
export const regionPath = (marketSlug: string, regionSlug: string): string => {
  const market = marketSlug.toLowerCase()
  const country = marketCountryCodes[market]
  if (!country) return `/${market}/${regionSlug}`

  return country === market
    ? `/${country}/${regionSlug}`
    : `/${country}/${market}/${regionSlug}`
}

export default regionPath
